<template>
  <el-dialog
    :title="$t('SeaExport.ServiceInformation')"
    :visible.sync="dialogShow"
    no="1"
    width="900px"
  >
    <div>
      <el-tabs v-model="activeName" no="2" type="card" @tab-click="handleClick">
        <el-tab-pane no="3" :label="$t('SeaExport.ScopeServices')" name="ScopeServices">
          <div>
            <el-button-group>
              <el-button no="4" :class="{ 'selected': isSh }" @click="selectTab(true)">
                {{ $t('OperationGuide.ShanghaiPort') }}
              </el-button>
              <el-button no="5" :class="{ 'selected': !isSh }" @click="selectTab(false)">
                {{ $t('OperationGuide.QingdaoPort') }}
              </el-button>
            </el-button-group>
            <div style="height: 20px" />
          </div>
          <div no="6" class="text1"> {{ $t('OperationGuide.Text1') + shippingCompanyList.length + $t('OperationGuide.Text2') + carrierAgentList.length + $t('OperationGuide.Text3') }}</div>
          <div style="height: 15px" />
          <div no="7" class="h-px" />
          <div no="8" class="service-coverage">
            <p no="9" class="title1">{{ $t('CargoMsg.Cargo_CarrierShip') }}</p>
            <div no="10" class="container">
              <button v-for="item in shippingCompanyList" :key="item.uuid" class="button">{{ item.name }}</button>
            </div>
            <p no="11" class="title1">{{ $t('CargoMsg.Cargo_CarrierAgent') }}</p>
            <div no="12" class="container">
              <button v-for="item in carrierAgentList" :key="item.uuid" class="button">{{ item.name }}</button>
            </div>
            <p class="title1">{{ $t('CargoMsg.Cargo_Remarks') }}</p>
            <div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark1') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark2') }}</span>
              </div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark3') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark4') }}</span>
              </div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark5') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark6') }}</span>
              </div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark7') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark8') }}</span>
              </div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark9') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark10') }}</span>
              </div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark11') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark12') }}</span>
              </div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark13') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark14') }}</span>
              </div>
              <div>
                <span class="remarks">{{ $t('OperationGuide.Remark15') }}</span>
                <span class="remarks2">{{ $t('OperationGuide.Remark16') }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane no="13" :label="$t('SeaExport.DeletionGuide')" name="DeletionGuide">
          <div class="text1">{{ $t('OperationGuide.DeletionGuide') }}</div>
          <div style="height: 15px" />
          <div class="h-px" />
          <h4 class="title2">{{ $t('OperationGuide.Text4') }}</h4>
          <p class="sub-title">{{ $t('OperationGuide.Remark17') }}</p>
          <div class="text2">
            <span>{{ $t('OperationGuide.Remark18') }}</span>
            <span>{{ $t('OperationGuide.Remark19') }}</span>
            <span>{{ $t('OperationGuide.Remark20') }}</span>
            <div style="text-indent: 2em;flex-direction: column;display: flex;">
              <span>{{ $t('OperationGuide.Remark21') }}</span>
              <span>{{ $t('OperationGuide.Remark22') }}</span>
              <span>{{ $t('OperationGuide.Remark23') }}</span>
            </div>
          </div>
          <p class="sub-title">{{ $t('OperationGuide.Remark24') }}</p>
          <div class="text2">
            <span>{{ $t('OperationGuide.Remark25') }}</span>
            <span>{{ $t('OperationGuide.Remark26') }}</span>
            <span>{{ $t('OperationGuide.Remark27') }}</span>
          </div>
          <p class="sub-title">{{ $t('OperationGuide.Remark28') }}</p>
          <div class="text2">
            <span>{{ $t('OperationGuide.Remark29') }}</span>
            <span>{{ $t('OperationGuide.Remark30') }}</span>
          </div>
          <h4 class="title2">{{ $t('OperationGuide.Remark31') }}</h4>
          <template>
            <div class="container">
              <el-table
                :data="companyList"
                border
                fit
                stripe
                no="14"
                class="pro-table"
                size="small"
              >
                <el-table-column
                  prop="name"
                  :label="$t('OperationGuide.CarrierName')"
                  align="center"
                  width="250"
                  no="15"
                />
                <el-table-column
                  prop="address"
                  :label="$t('SeaExport.Address')"
                  align="center"
                  width="588"
                  no="16"
                />
              </el-table>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane no="17" :label="$t('SeaExport.BusinessData')" name="BusinessData">
          <div class="text1">{{ $t('OperationGuide.BusinessData') }}</div>
          <div style="height: 15px" />
          <div class="h-px" />
          <div style="height: 15px" />
          <template>
            <div>
              <!-- 下拉框 -->
              <div class="filter-container">
                <el-select v-model="selectedType" no="18" :placeholder="$t('CargoMsg.Cargo_BusinessType')">
                  <el-option
                    v-for="item in businessTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-select v-model="selectedAgent" no="19" :placeholder="$t('CargoMsg.Cargo_CarrierAgent')">
                  <el-option
                    v-for="item in agents"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <!-- 表格 -->
              <el-table
                :data="paginatedData"
                border
                fit
                stripe
                no="20"
                class="pro-table"
                size="small"
              >
                <el-table-column
                  prop="type"
                  :label="$t('CargoMsg.Cargo_BusinessType')"
                  align="center"
                  width="200"
                  no="21"
                />
                <el-table-column
                  prop="agent"
                  :label="$t('CargoMsg.Cargo_CarrierAgent')"
                  align="center"
                  width="189"
                  no="22"
                />
                <el-table-column
                  prop="fileName"
                  :label="$t('CargoMsg.Cargo_FileName')"
                  align="center"
                  width="350"
                  no="23"
                />
                <el-table-column
                  :label="$t('CargoMsg.Cargo_Operation')"
                  align="center"
                  width="100"
                  no="24"
                >
                  <template slot-scope="scope">
                    <el-button no="25" type="text" size="small" @click="handleDownload(scope.row)">{{ $t('CargoMsg.Cargo_Download') }}</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页 -->
              <el-pagination
                background
                layout="prev, pager, next"
                :total="filteredData.length"
                :page-size="pageSize"
                no="26"
                @current-change="handlePageChange"
              />
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button no="27" @click="dialogShow = false">{{ $t('SeaExport.Close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'

export default {
  name: 'ServiceInformationDialogNew',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      activeName: 'ScopeServices',
      dialogShow: false,
      seaHouseThirdPartyMappingUtil: null,
      wseThirdPartyMappingUtil: null,
      isSh: true, // 默认展示上海港数据
      shippingCompanyList: [], // 页面展示船公司
      carrierAgentList: [], // 页面展示船代
      seaHouseCache: {
        shippingCompanyList: [] // 船公司
      },
      wseCache: {
        carrierAgentCompanyList: [], // 船代
        carrierCompanyList: [], // 船公司
        carrierAgentCompanyListForSH: [], // 未斯上海船代
        carrierCompanyListForSH: [], // 未斯上海船公司
        carrierAgentCompanyListForQD: [], // 未斯青岛船代
        carrierCompanyListForQD: [] // 未斯青岛船公司
      },
      companyList: [
        { uuid: '1', name: this.$t('OperationGuide.CompanyName1'), address: this.$t('OperationGuide.CompanyAddress1') },
        { uuid: '2', name: this.$t('OperationGuide.CompanyName2'), address: this.$t('OperationGuide.CompanyAddress2') },
        { uuid: '3', name: this.$t('OperationGuide.CompanyName3'), address: this.$t('OperationGuide.CompanyAddress3') },
        { uuid: '4', name: this.$t('OperationGuide.CompanyName4'), address: this.$t('OperationGuide.CompanyAddress4') },
        { uuid: '5', name: this.$t('OperationGuide.CompanyName5'), address: this.$t('OperationGuide.CompanyAddress5') },
        { uuid: '6', name: this.$t('OperationGuide.CompanyName6'), address: this.$t('OperationGuide.CompanyAddress6') },
        { uuid: '7', name: this.$t('OperationGuide.CompanyName7'), address: this.$t('OperationGuide.CompanyAddress7') },
        { uuid: '8', name: this.$t('OperationGuide.CompanyName8'), address: this.$t('OperationGuide.CompanyAddress8') },
        { uuid: '9', name: this.$t('OperationGuide.CompanyName9'), address: this.$t('OperationGuide.CompanyAddress9') },
        { uuid: '10', name: this.$t('OperationGuide.CompanyName10'), address: this.$t('OperationGuide.CompanyAddress10') },
        { uuid: '11', name: this.$t('OperationGuide.CompanyName11'), address: this.$t('OperationGuide.CompanyAddress11') },
        { uuid: '12', name: this.$t('OperationGuide.CompanyName12'), address: this.$t('OperationGuide.CompanyAddress12') },
        { uuid: '13', name: this.$t('OperationGuide.CompanyName13'), address: this.$t('OperationGuide.CompanyAddress13') },
        { uuid: '14', name: this.$t('OperationGuide.CompanyName14'), address: this.$t('OperationGuide.CompanyAddress14') }
      ],
      selectedType: '',
      selectedAgent: '',
      currentPage: 1,
      pageSize: 10,
      businessTypes: [
        { value: 'all', label: this.$t('CargoMsg.Cargo_All') },
        { value: this.$t('OperationGuide.DropOffGoods'), label: this.$t('OperationGuide.DropOffGoods') },
        { value: this.$t('OperationGuide.CounterDeletion'), label: this.$t('OperationGuide.CounterDeletion') },
        { value: this.$t('OperationGuide.CertificateOfNonBoarding'), label: this.$t('OperationGuide.CertificateOfNonBoarding') }
      ],
      agents: [
        { value: 'all', label: this.$t('CargoMsg.Cargo_All') },
        { value: this.$t('OperationGuide.CompanyName6'), label: this.$t('OperationGuide.CompanyName6') },
        { value: this.$t('OperationGuide.CompanyName11'), label: this.$t('OperationGuide.CompanyName11') },
        { value: this.$t('OperationGuide.CompanyName1'), label: this.$t('OperationGuide.CompanyName1') },
        { value: this.$t('OperationGuide.CompanyName5'), label: this.$t('OperationGuide.CompanyName5') },
        { value: this.$t('OperationGuide.CompanyName14'), label: this.$t('OperationGuide.CompanyName14') },
        { value: this.$t('OperationGuide.CompanyName15'), label: this.$t('OperationGuide.CompanyName15') },
        { value: this.$t('OperationGuide.CompanyName2'), label: this.$t('OperationGuide.CompanyName2') },
        { value: this.$t('OperationGuide.CompanyName16'), label: this.$t('OperationGuide.CompanyName16') },
        { value: this.$t('OperationGuide.CompanyName4'), label: this.$t('OperationGuide.CompanyName4') },
        { value: this.$t('OperationGuide.CompanyName7'), label: this.$t('OperationGuide.CompanyName7') },
        { value: this.$t('OperationGuide.CompanyName17'), label: this.$t('OperationGuide.CompanyName17') },
        { value: this.$t('OperationGuide.CompanyName9'), label: this.$t('OperationGuide.CompanyName9') }
      ],
      tableData: [
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName11'), fileName: '上海振华-未上船证明资料.zip' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName2'), fileName: '上海中外运-未上船证明资料.zip' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName5'), fileName: '上海顺德-未上船证明资料.zip' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName14'), fileName: '东方海外-未上船证明资料.zip' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName15'), fileName: '上港联合-未上船证明资料.rar' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName6'), fileName: '上海航华-未上船证明资料.rar' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName1'), fileName: '上海外代-未上船证明资料.rar' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName16'), fileName: '上海中联-未上船证明资料.rar' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName4'), fileName: '上海华港-未上船证明资料.rar' },
        { type: this.$t('OperationGuide.CertificateOfNonBoarding'), agent: this.$t('OperationGuide.CompanyName7'), fileName: '上海民生-未上船证明资料.rar' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName6'), fileName: '上海航华-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName17'), fileName: '鹏华-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName15'), fileName: '上港联合-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName16'), fileName: '上海中联-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName9'), fileName: '上海鹏海-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName4'), fileName: '上海华港-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName14'), fileName: '东方海外-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName5'), fileName: '上海顺德-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName7'), fileName: '上海民生-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.CounterDeletion'), agent: this.$t('OperationGuide.CompanyName11'), fileName: '上海振华-柜台删单资料.zip' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName5'), fileName: '上海顺德-落货资料.zip' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName4'), fileName: '上海华港-落货资料.zip' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName15'), fileName: '上港联合-落货资料.zip' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName2'), fileName: '上海中外运-落货资料.zip' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName14'), fileName: '东方海外-落货资料.zip' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName9'), fileName: '上海鹏海-落货资料.zip' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName16'), fileName: '上海中联-落货资料.rar' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName1'), fileName: '上海外代-落货资料.rar' },
        { type: this.$t('OperationGuide.DropOffGoods'), agent: this.$t('OperationGuide.CompanyName6'), fileName: '上海航华-落货资料.zip' }
      ]
    }
  },
  computed: {
    filteredData() {
      let filtered = this.tableData

      if (this.selectedType && this.selectedType !== 'all') {
        filtered = filtered.filter(item => item.type === this.selectedType)
      }

      if (this.selectedAgent && this.selectedAgent !== 'all') {
        filtered = filtered.filter(item => item.agent === this.selectedAgent)
      }

      return filtered
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredData.slice(start, end)
    }
  },
  watch: {
    visible(newVal) {
      this.dialogShow = newVal
    },
    dialogShow(newVal) {
      if (!newVal) {
        this.activeName = 'ScopeServices'
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.dialogShow = true
    }
  },
  async mounted() {
    this.seaHouseThirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
    this.seaHouseCache.shippingCompanyList = this.seaHouseThirdPartyMappingUtil.getListByDataType('carrier')
    this.seaHouseCache.shippingCompanyList.push({ name: 'DJS—东进' })
    this.seaHouseCache.shippingCompanyList.push({ name: 'FSL—星洋船务' })
    this.seaHouseCache.shippingCompanyList.push({ name: 'JOT—日本国际商船' })
    this.seaHouseCache.shippingCompanyList.push({ name: 'STX—泛洋' })
    this.wseThirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
    this.wseCache.carrierCompanyList = this.wseThirdPartyMappingUtil.getListByDataType('carrier')
    this.wseCache.carrierCompanyListForSH = this.wseCache.carrierCompanyList.filter(t => t.filterValue === 'sh')
    this.wseCache.carrierCompanyListForQD = this.wseCache.carrierCompanyList.filter(t => t.filterValue === 'qd')
    this.wseCache.carrierAgentCompanyList = this.wseThirdPartyMappingUtil.getListByDataType('carrierAgent')
    this.wseCache.carrierAgentCompanyListForSH = this.wseCache.carrierAgentCompanyList.filter(t => t.filterValue === 'sh')
    this.wseCache.carrierAgentCompanyListForQD = this.wseCache.carrierAgentCompanyList.filter(t => t.filterValue === 'qd')
    this.handleDataShow()
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    selectTab(isSh) {
      this.isSh = isSh
      this.handleDataShow()
    },
    handleDataShow() {
      this.shippingCompanyList = this.isSh ? this.seaHouseCache.shippingCompanyList : this.wseCache.carrierCompanyListForQD
      this.carrierAgentList = this.isSh ? this.wseCache.carrierAgentCompanyListForSH : this.wseCache.carrierAgentCompanyListForQD
    },
    handleDownload(row) {
      // Implement your download logic here
      console.log('Downloading:', row.fileName)
      window.open(URL.seaExport.downloadBusinessDataUrl + '?sessionId=' + getToken() + '&fileName=' + row.fileName)
    },
    handlePageChange(page) {
      this.currentPage = page
    }
  }
}
</script>

<style scoped>

.selected {
  background-color: #E9F1FB;
  color: #1F75D5;
}
.container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  user-select: text;
}

.button {
  width: 150px;
  height: 50px;
  margin: 5px;
  padding: 10px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #333;
  display: flex; /* 添加flex布局 */
  align-items: center; /* 垂直居中对齐 */
  justify-content: center; /* 水平居中对齐 */
}

.dialog-footer {
  text-align: right;
}

.el-dialog {
  background-color: #fafafa;
}

.el-tab-pane {
  padding: 20px;
}

.text1 {
  height: 30px !important;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: .5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: rgb(40 40 40);
}

.h-px {
  height: 1px !important;
  background-color: rgb(229 229 229);
}

.service-coverage .title1 {
  display: inline-block;
  vertical-align: middle;
  font-family: "PingFangSC-Semibold", "PingFang SC";
  font-size: 24px;
  color: #282828;
  font-weight: 600;
  line-height: 33px;
  position: relative; /* 相对定位，以便使用伪元素 */
  padding-left: 24px; /* 给伪元素留出空间 */
}

.service-coverage .title1::before {
  content: "";
  display: inline-block;
  position: absolute; /* 绝对定位 */
  top: 50%;
  left: 0; /* 放置在左边 */
  transform: translateY(-50%); /* 垂直居中 */
  width: 4px;
  height: 24px;
  background-color: #5572fd;
}

.title1 {
  margin-top: 30px;
  border-left-color: rgb(59 130 246);
}

.remarks {
  line-height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #282828;
  text-align: right;
  width: 170px;
  display: inline-block;
  margin-right: 15px;
}
.remarks2 {
  font-size: 14px;
  font-weight: 400;
  color: #282828;
}

.title2 {
  text-align: center;
  font-size: 22px;
  line-height: 36px;
  color: rgb(40 40 40);
}
.sub-title {
  margin-top: 10px;
  margin-bottom: 10px;
  border-width: 0px;
  border-left-width: 3px;
  border-style: solid;
  border-color: rgb(255 152 7);
  text-indent: 10px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  color: rgb(255 152 7);
}
.text2 {
  color: rgb(40 40 40);
  line-height: 2;
}

</style>
